import React from 'react';
import { motion } from 'framer-motion';
import { Mic, MessageSquare, Phone, Mail } from 'lucide-react';
export function ChannelCards() {
  const channels = [{
    icon: <Mic size={24} data-id="element-108" />,
    title: 'Voice',
    desc: 'Just talk naturally. MR transcribes and acts.'
  }, {
    icon: <MessageSquare size={24} data-id="element-109" />,
    title: 'Slack / Teams',
    desc: 'Tag @MR in any channel to trigger a Stream.'
  }, {
    icon: <Phone size={24} data-id="element-110" />,
    title: 'SMS',
    desc: 'Text your dedicated MR number on the go.'
  }, {
    icon: <Mail size={24} data-id="element-111" />,
    title: 'Email',
    desc: 'Forward emails to MR to handle follow-ups.'
  }];
  return <section className="py-12 px-6 bg-white relative overflow-hidden" data-id="element-112">
      {/* Subtle Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-113" />

      <div className="inner-container relative z-10" data-id="element-114">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-115">
          {channels.map((channel, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border-y border-r border-gray-200 rounded-r-xl p-6 shadow-sm hover:shadow-lg hover:shadow-teal/5 transition-shadow relative overflow-hidden" data-id="element-116">
              {/* Gradient Left Border */}
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-purple to-teal" data-id="element-117" />

              <div className="text-teal mb-4 bg-teal/10 w-12 h-12 rounded-lg flex items-center justify-center" data-id="element-118">
                {channel.icon}
              </div>
              <h3 className="font-poppins font-semibold text-lg mb-2 text-gray-900" data-id="element-119">
                {channel.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-120">
                {channel.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}